import { useForm } from "react-hook-form";
import { useState, useEffect } from "react";
import Form from "../../../ui/Form";
import TextField from "../../../ui/TextField";
import { postLottery } from "../../../../services/apiCourseApplicant";
import { getCourseApplicantList } from "../../../../services/apiCourseApplicant";
import { getCodeMasterList } from "../../../../services/apiCodeMaster";
import ModalScreenTitle from "../../../layout/admin/ModalScreenTitle";
import Explanation from "../../../layout/admin/Explanation";
import Button from "../../../ui/Button";
import dtStyles from "../../../features/DataTable.module.scss";
import styles from "../../../layout/admin/Main.module.scss";
import modalStyles from "../../../layout/admin/Modal.module.scss";
import Loading from "../../../../components/ui/Loading";
import Progress from "../../../../components/ui/Progress";

const lotteryStatusWin = "2"; // 当選
const lotteryStatusNotSelected = "3"; // 落選

const tableMeata = [
  { key: "login_id", label: "学生番号" },
  { key: "name", label: "氏名" },
  { key: "street_name1", label: "町名" },
  { key: "lottery_status", label: "	当選状況" },
];

const LotteryModal = (props) => {
  // 講座ID
  const [courseId, setCourseId] = useState(props.course_id);
  // ローディング表示
  const [loading, setLoading] = useState(false);
  // 抽選完了フラグ
  const [compFlg, setCompFlg] = useState(false);
  // 抽選実行済みフラグ
  const [lotteryExecuted, setLotteryExecuted] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  // 当選人数をチェック
  const winNumValue = watch("win_num");
  const winNum = winNumValue ? parseInt(winNumValue) : 0;

  // 抽選結果登録
  async function onSubmit(data) {
    const json = await postLottery(courseId, data);
    if (json) {
      // 抽選完了画面表示
      setCompFlg(true);
      // 抽選完了画面の「閉じる」で親画面を再レンダリングさせる為に一時的に親画面の再レンダリングをfalseに設定
      // useEffectが動作するが再レンダリングがfalseの場合は再レンダリングさせない
      props.setReloadFlag(false);
    }
  }

  // 一覧データ
  const [tableData, setTableData] = useState([]);
  // 当選状況ドロップダウンリスト
  const [lotteryStatus, setLotteryStatus] = useState([]);
  useEffect(() => {
    // ローディング表示開始
    setLoading(true);
    if (!props.showFlag) return;
    (async function () {
      // リストデータの選択肢データセット
      const lsData = await getCodeMasterList({ code: "CD003" });
      setLotteryStatus(
        lsData.map((d) => {
          return { label: d.d_text, value: d.d_value };
        }),
      );
      // 抽選対象学生の条件設定
      const data = await getCourseApplicantList(
        { id: courseId },
        {
          is_graduation: false, // 卒業生でない
          is_rejection: false, // ログイン拒否されていない
          attendance_status: "1", // 受講ステータス「未受講」
        },
      );

      if (data === undefined || !data) return;
      const newData = data.map((d, i) => {
        setValue("course_applicant_id_" + i, d.course_applicant_id);
        // 既存の当選状況をreact-hook-formに設定
        setValue("lottery_status_" + i, d.lottery_status);
        return {
          key: d.login_id,
          login_id: d.login_id,
          name: d.is_wheelchair ? `【車いす】${d.name}` : d.name,
          street_name1: d.street_name1,
          birthday: d.birthday,
          lottery_status: d.lottery_status,
        };
      });
      setTableData(newData);
      // target_numに件数を設定
      setValue("target_num", newData.length);
      // 当選人数を設定（既に抽選済みの場合）
      const winnerCount = newData.filter(
        (d) => String(d.lottery_status) === lotteryStatusWin,
      ).length;
      if (winnerCount > 0) {
        setValue("win_num", winnerCount);
      }
      // ローディング表示終了
      setLoading(false);
    })();
  }, []);

  const closeModal = () => {
    // モーダル閉じる
    props.setShowModal(false);
    if (compFlg) {
      // 親画面を再描画
      const nurl = new URL(window.location.href);
      window.location.href =
        nurl.origin + "/admin/course/detail/" + props.course_id + "/2";
    } else {
      // 親画面の再レンダリングフラグをtrueに戻すことで親画面を再レンダリング
      props.setReloadFlag(true);
    }
  };

  const simpleDataTable = (tableData) => {
    if (tableData.length < 1) {
      return <></>;
    }
    return (
      <div className={`${dtStyles.datatable} ${dtStyles.scrollTable} mb-5`}>
        <table className={dtStyles.responsivetable}>
          <thead>
            <tr>
              {tableMeata.map((field, i) => (
                <th key={i}>{field.label} </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {tableData.map((record, i) => (
              <tr key={i}>
                <td className="w-25">{record.login_id}</td>
                <td className="w-25">{record.name}</td>
                <td className="w-25">{record.street_name1}</td>
                <td className="w-25">
                  {returnLsField(i, record.lottery_status)}
                  <div hidden>
                    <input
                      className="input"
                      type="text"
                      name={"course_applicant_id_" + i}
                      {...register("course_applicant_id_" + i, {})}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  // 当選状況
  const returnLsField = (index, value) => {
    return (
      <select
        {...register("lottery_status_" + index)}
        defaultValue={value}
        onChange={(e) => {
          const newTableData = [...tableData];
          newTableData[index].lottery_status = e.target.value;
          setTableData(newTableData);
          setValue("lottery_status_" + index, e.target.value);
        }}
      >
        {lotteryStatus.map((option) => (
          <option value={option.value} key={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    );
  };

  const lottery = () => {
    // 当選人数バリデーション
    if (!winNum || winNum <= 0) {
      alert("当選人数には1以上の数値を入力してください。");
      return;
    }
    // 当選人数入力値の分、当選者をランダムで選ぶ
    const applicantCount = tableData.length;
    if (winNum > applicantCount) {
      alert("当選人数が申込者数を超えています。");
      return;
    }
    // 申込者にランダムで値を付与し、その値でソート
    const shuffled = tableData
      .map((value) => ({ value, sort: Math.random() }))
      .sort((a, b) => a.sort - b.sort)
      .map(({ value }) => value);
    // 先頭から当選人数の入力値分を当選者とする
    const selected = shuffled.slice(0, winNum);
    // 当選状況プルダウン選択
    const newTableData = tableData.map((record, index) => {
      // 当選者リストに含まれているか
      const isWinner = selected.some(
        (winner) => winner.login_id === record.login_id,
      );
      const newStatus = isWinner ? lotteryStatusWin : lotteryStatusNotSelected;
      // 当選状況を設定
      setValue("lottery_status_" + index, newStatus);
      return {
        ...record,
        lottery_status: newStatus,
      };
    });
    setTableData(newTableData);
    setLotteryExecuted(true);
  };
  const returnContents = (flg) => {
    if (flg) {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.lotterymodalContent}>
            <div className={modalStyles.lotteryModalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>申込者抽選完了</ModalScreenTitle>
            <Explanation>抽選が完了しました。</Explanation>
            <div className={styles.buttonbox}>
              <a onClick={() => closeModal()}>
                <span className={styles.decoration}>閉じる</span>
              </a>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div id="overlay" className={modalStyles.overlay}>
          <div id="modalContent" className={modalStyles.modalContent}>
            <div className={modalStyles.modalButtonWrap}>
              <button
                className={`${modalStyles.closeButton}`}
                onClick={() => closeModal()}
                aria-label="閉じる"
              >
                <span></span>
                <span></span>
              </button>
            </div>
            <ModalScreenTitle>申込者抽選</ModalScreenTitle>
            <Explanation>
              必要事項をご入力の上、抽選ボタンを押してください（既存の抽選結果は上書きされます）。
              <br />
              ※ログイン拒否されている学生および卒業生は選ばれません。
            </Explanation>
            <Form onSubmitHandler={handleSubmit(onSubmit)}>
              <TextField
                type="number"
                errors={errors}
                register={register}
                label="当選人数"
                name="win_num"
                required={true}
              />
              <div className={styles.buttonbox}>
                <Button onClick={() => lottery()} styleType="new">
                  抽選
                </Button>
              </div>
              <Explanation>
                以下の結果を確認し、問題なければ登録ボタンを押してください。
              </Explanation>
              <div className={dtStyles.datatable}>
                <span
                  className={dtStyles.datatable__recordnum}
                >{`当選${tableData.filter((record) => String(record.lottery_status) === lotteryStatusWin).length}件 / 全${tableData.length}件`}</span>
                <div hidden>
                  <input
                    type="text"
                    name="target_num"
                    {...register("target_num", {})}
                  />
                </div>
                {simpleDataTable(tableData)}
                {lotteryExecuted &&
                  (() => {
                    const winnerCount = tableData.filter(
                      (record) =>
                        String(record.lottery_status) === lotteryStatusWin,
                    ).length;
                    const diff = winnerCount - winNum;
                    return diff !== 0 ? (
                      <Explanation is_caution={true}>
                        ！当選者が当選人数より{Math.abs(diff)}人
                        {diff > 0 ? "多い" : "少ない"}です。
                      </Explanation>
                    ) : (
                      <></>
                    );
                  })()}
                <div className={styles.buttonbox}>
                  <Button
                    type="submit"
                    styleType="new"
                    disabled={
                      !winNum ||
                      winNum <= 0 ||
                      tableData.filter(
                        (record) =>
                          String(record.lottery_status) === lotteryStatusWin,
                      ).length !== winNum
                    }
                  >
                    登録
                  </Button>
                </div>
                <div className={styles.buttonbox}>
                  <a onClick={() => closeModal()}>
                    <span className={styles.decoration}>閉じる</span>
                  </a>
                </div>
              </div>
            </Form>
          </div>
          {loading ? <Loading /> : <></>}
          {loading ? <Progress /> : <></>}
        </div>
      );
    }
  };
  return <>{props.showFlag ? returnContents(compFlg) : <></>}</>;
};

export default LotteryModal;
